import { api, applyFirebaseTokenRetry } from "./api";
import axios, { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

export type UnidadeToSend = {
  cliente: string,
  conjunto: string,
  dataAlteracao: number,
  local: string,
  nome: string
};

class Unity {


  private apiDev = applyFirebaseTokenRetry(axios.create({
    baseURL: `${process.env.REACT_APP_AXYMA_MICROSSERVICES_APIS_URL}/empresa`
  }));

  newUnity = async (body: AuthBodyType, unidade: UnidadeToSend) => {
    try {
      const data: AxiosResponse = await api.post('/unidade/newUnidade', {
        ...body,
        unidade
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log('erro --->', error);
        return error.response?.status;
      }
    }
  };

  editUnity = async (body: AuthBodyType, unidade: string, nome: string) => {
    try {
      const data: AxiosResponse = await api.post('/unidade/changeUnidade', {
        ...body,
        unidade,
        nome
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log('erro --->', error);
        return error.response?.status;
      }
    }
  };

  deleteUnity = async (body: AuthBodyType, unidade: string, conjunto: string) => {
    try {
      const data: AxiosResponse = await api.post('/unidade/deleteUnidade', {
        ...body,
        unidade,
        conjunto
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log('erro --->', error);
        return error.response?.status;
      }
    }
  };

  duplicateUnity = async (body: AuthBodyType, unidade: string) => {
    try {
      const data: AxiosResponse = await api.post('/unidade/duplicateUnidade', {
        ...body,
        unidade,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log('erro --->', error);
        return error.response?.status;
      }
    }
  };

  addQRCode = async (body: AuthBodyType, unity: string) => {
    try {
      const data: AxiosResponse = await api.post('/unidade/addQRCode', {
        ...body,
        unity,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log('erro --->', error);
        return error.response?.status;
      }
    }
  };

  getUnitsByFormId = async (body: AuthBodyType, formId: string) => {
    try {
      const data: AxiosResponse = await this.apiDev.get(`/unidade`, {params: {Form: formId}, headers: { ...body } });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if(axios.isAxiosError(error)){
        console.error(error.message);
        console.log('erro --->', error);
        return error.response?.status;
      }
    }
  };

}

export default Unity;
